import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_WEIGHT_UNITIES_APP_PATHS } from '../constants/weight-unities-app-paths.constants';
import AdminWeightUnitiesListView from '../views/admin/AdminWeightUnities.view';

export default function AdminWeightUnitiesRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_WEIGHT_UNITIES_APP_PATHS.WEIGHT_UNITIES_LIST} component={AdminWeightUnitiesListView} />
    </React.Fragment>
  );
}
